import request from './request'
import type { orderData } from './interface'

export const getProvider = () =>
  request({
    url: '/provider/all',
    method: 'GET',
  })
export const getChannel = () =>
  request({
    url: '/channel/all',
    method: 'GET',
  })
export const getPayeeChannel = () =>
  request({
    url: '/generic/payment/methods/payee',
    method: 'GET',
  })
// 获取金额限制
export const getLimitMoney = () =>
  request({
    url: '/order/recharge/limitAmt',
    method: 'GET',
  })
// 获取普通金额按钮列表
export const getMoneyButtonList = () =>
  request({
    url: '/carbon-wallet/private/user/order/recharge/list/config',
    method: 'GET',
  })
// 获取充值比例按钮列表
export const getProportionButtonList = () =>
  request({
    url: '/carbon-promotion/private/user/activity/deposit/bonus/homepage',
    method: 'GET',
  })
// 创建订单
export const createOrder = (data: orderData) =>
  request({
    url: '/carbon-wallet/private/user/order/recharge/create',
    method: 'POST',
    data,
  })
// 查询订单
export const checkingOrder = ({ orderNo }) =>
  request({
    url: `/carbon-wallet/private/user/order/recharge/${orderNo}`,
    method: 'GET',
    // headers: {
    //   'Access-Token': token,
    // },
  })
// 保存用户支付信息
export const savePaymentInfo = (data) =>
  request({
    url: '/carbon-wallet/private/user/wallet/payment/info/update',
    method: 'POST',
    data,
  })
